const $$splitComponentImporter = () => import('/src/src/routes/_session/login/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { defineMessage } from "react-intl";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";
export const Route = createFileRoute("/_session/login/")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: zodValidator(z.object({
    referrer: z.string().optional(),
    error: z.string().optional(),
    // The SSO flow lands back here as /login?userToken=<jwt>, which AuthTokenDetector consumes
    userToken: z.string().optional(),
    // Set to TEAMS_TAB when the Teams login router sends the user here to sign in
    platform: z.string().optional()
  })),
  staticData: {
    pageTitle: defineMessage({
      defaultMessage: "Login",
      description: "Page title"
    })
  }
});